import ContactBoxes from '../modules/contact-boxes';

const sections = document.querySelectorAll('[data-contact-boxes]');
const initContactBoxes = sections => {
    if (!sections) return;

    sections.forEach(el => {
        new ContactBoxes(el);
    });
};

initContactBoxes(sections);
